import React from "react";
import { PeekBox, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
export const DownloadScopeBanner = ({ label }) => {
    const theme = useTheme();
    return (React.createElement(PeekBox, { "data-testid": "download-scope-banner", sx: {
            px: 1.5,
            py: 1,
            backgroundColor: "grey.50",
            borderLeft: "3px solid",
            borderColor: theme.palette.teal[300],
        } },
        React.createElement(PeekTypography, { variant: "body1", color: "info.main" }, label)));
};
export default DownloadScopeBanner;
